var preSemester = false;
var environment;

import { md5 } from 'js-md5';


function pickProductionApi() {

    let apiUrl = 'https://api.tttc.ca';

    try {
        const hash = md5(window.navigator.userAgent) 
        const hex = "0x" + hash.replace(/-/g, "");
        const decimal = BigInt(hex).toString();
        let vid = decimal.slice(0,6);      
        vid = parseInt(vid);

        if (vid % 3 === 0) {
            // direct 30% of users to the new API server
            apiUrl = 'https://ecs-api.tttc.ca';    
        }
    } catch(e) {
        console.log(e);
        console.log("Error picking API server");
    }

    return apiUrl;
}


if (window.location.hostname === 'localhost') {

    // window.apiUrl = process.env.API_URL || 'http://ubuntu.local.com';
    // window.apiWS = process.env.API_WS || 'http://ubuntu.local.com:8080';

     // window.apiUrl = process.env.API_URL || 'https://api.tttc.ca';
     // window.apiWS = process.env.API_WS || 'https://api.tttc.ca:8080';


    window.apiUrl = process.env.API_URL || 'https://dev.tttc.ca';
    window.apiWS = process.env.API_WS || 'https://dev.tttc.ca:8080';   


    window.baseUrl = 'http://localhost:8080';

    //window.chatUrl = process.env.CHAT_URL || 'http://ubuntu.local.com:3030';
    //window.chatWS = process.env.CHAT_WS || 'ws://ubuntu.local.com:3030/websocket';
    window.chatUrl = 'https://chat.tttc.ca';
    window.chatWS = 'wss://chat.tttc.ca/websocket';
    environment = 'local';

} else if (window.location.hostname === 'retro.tttc.ca') {    
    
    window.apiUrl = 'https://api.tttc.ca';
    window.apiWS = window.apiUrl + ':8080';        

    window.baseUrl = 'https://retro.tttc.ca';
    window.chatUrl = 'https://chat.tttc.ca';
    window.chatWS = 'wss://chat.tttc.ca/websocket';
    environment = 'production';
} else if (window.location.hostname === 'portal.tttc.ca') {    
    
    window.apiUrl = 'https://api.tttc.ca';
    window.apiWS = window.apiUrl + ':8080';        

    window.baseUrl = 'https://portal.tttc.ca';
    window.chatUrl = 'https://chat.tttc.ca';
    window.chatWS = 'wss://chat.tttc.ca/websocket';
    environment = 'production';
}
else if (window.location.hostname === 'onboarding.tttc.ca') {
    window.apiUrl = 'https://onboarding-api.tttc.ca';
    window.apiWS = 'https://onboarding-api.tttc.ca:8080';
    window.baseUrl = 'https://onboarding.tttc.ca';
    window.chatUrl = 'https://chat.tttc.ca';
    window.chatWS = 'wss://chat.tttc.ca/websocket';
    environment = 'dev';
}
 else {
    window.apiUrl = 'https://dev.tttc.ca';
    window.apiWS = 'https://dev.tttc.ca:8080';
    window.baseUrl = 'https://dev-portal.tttc.ca';
    window.chatUrl = 'https://chat.tttc.ca';
    window.chatWS = 'wss://chat.tttc.ca/websocket';
    environment = 'dev';
}


import Vue from 'vue';

import VueTranslate from 'vue-translate-plugin';
import revuest from "revuest";
import VueHtml5Editor from './packages/vue-html5-editor/';
import VueSocketIO from 'vue-socket.io'
import toastr from 'toastr';
import VueAnalytics from 'vue-analytics'
import VueGtag from './packages/vue-gtag/'
import VueSweetAlert from 'vue-sweetalert'
import { ClientTable, Event } from 'vue-tables-2';
import infiniteScroll from './components/reusable/vue-infinite-scroll';
import Vue2Filters from 'vue2-filters';
import VTooltip from 'v-tooltip';
import VueScrollTo from 'vue-scrollto';
import ToggleButton from 'vue-js-toggle-button';
import VueSelect from 'vue-select';
import VueModal from 'vue-js-modal';
import VueMediaEmbed from 'vue-media-embed';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

import store from './store';
import router from './router';
import discordRouter from './router';
import filters from './filters';
import UAParser from 'ua-parser-js';

Vue.use(VueSweetAlert);
Vue.use(VueTranslate);
Vue.use(require('vue-full-calendar'));
Vue.use(revuest);
Vue.use(ClientTable);
Vue.use(infiniteScroll);
Vue.use(Vue2Filters);
Vue.use(VTooltip);
Vue.use(VueScrollTo);
Vue.use(ToggleButton);


Vue.use(VueModal);
Vue.component('v-select', VueSelect);


Vue.use(VueMediaEmbed, { store })

import 'swiper/dist/css/swiper.css'
import 'vue2-autocomplete-js/dist/style/vue2-autocomplete.css'
import 'videojs-contrib-dash'; // Modifies videojs to support MPEG-DASH

import moment from 'moment';
import axios from 'axios';
import auth from './services/auth';
import chat from './services/chat';

let gaId, ga4Id;

if (window.location.hostname === 'portal.tttc.ca') {
    gaId = 'UA-28828256-2'
} else {
    gaId = 'UA-98637813-1'
}

ga4Id = 'G-XR3S99JTVF'

Vue.use(VueAnalytics, {
    id: gaId,
    domain: 'none',
    router
});


Vue.use(VueGtag, {
    config: {
        id: ga4Id
    }
}, router);



Vue.component('editable', {
    template: '<div contenteditable="true" @input="update"></div>',
    props: ['content'],
    mounted: function() {
        this.$el.innerText = this.content;
    },
    methods: {
        update: function(event) {
            this.$emit('update', event.target.innerText);
        }
    }
})

Vue.use(new VueSocketIO({
    // debug: true,
    connection: window.apiWS,
}));

Vue.use(VueHtml5Editor, {
    image: {
        server: 'https://s3-us-west-2.amazonaws.com/ttto-discussion-images-full/',
        awsSignatureUrl: window.apiUrl + '/aws-signature?bucket=ttto-discussion-images-full',
        sizeLimit: 512 * 9096,
        compress: true,
        width: 1920,
        height: 1280,
        quality: 80,

        uploadHandler(response) {
            // srsly amazon
            var parser = new DOMParser();
            var xmlDoc = parser.parseFromString(response, "text/xml");
            return xmlDoc.getElementsByTagName("Location")[0].childNodes[0].nodeValue;
        }
    },
    video: {
        server: 'https://s3-us-west-2.amazonaws.com/ttto-discussion-videos/',
        awsSignatureUrl: window.apiUrl + '/aws-signature?bucket=ttto-discussion-videos',

        uploadHandler(response) {
            var parser = new DOMParser();
            var xmlDoc = parser.parseFromString(response, "text/xml");
            return xmlDoc.getElementsByTagName("Location")[0].childNodes[0].nodeValue;
        }
    },
    file: {
        server: 'https://s3-us-west-2.amazonaws.com/ttto-discussion-files/',
        awsSignatureUrl: window.apiUrl + '/aws-signature?bucket=ttto-discussion-files',

        uploadHandler(response) {
            var parser = new DOMParser();
            var xmlDoc = parser.parseFromString(response, "text/xml");
            return xmlDoc.getElementsByTagName("Location")[0].childNodes[0].nodeValue;
        }
    }
});






var bus = new Vue({}); // empty Vue instance to use as an event bus

Object.defineProperty(Vue.prototype, '$bus', {
    get() {
        return this.$root.bus;
    }
});

// ===== Bootstrap components integration (JQuery needed) ======
window.$ = window.jQuery = require('jquery');
require('bootstrap-sass');


// ======================= Base Component ======================
import App from './App';

// ======================== Vue Instance =======================
/* eslint-disable no-new */
new Vue({
    router,
    store,
    el: '#app',
    data: {
        bus: bus,
        title: 'Think Tank Portal',
        preSemester: preSemester,
        environment: environment
    },
   async beforeCreate() {

        // axios.get(window.apiUrl + '/pre-semester').then(function(response) {
        //      localStorage.preSemester = response.data;
        // });
    },
    async mounted() {
      setInterval(() => {          
        if (!this.$socket.connected) {
              this.$socket.connect();
            }
        }, 5000);
    },
    sockets: {
        connect: async function(c) {
            if (localStorage.user_id) {
                const fp = await FingerprintJS.load();
                const result = await fp.get();
                const browserId = result.visitorId;
                this.$store.dispatch('populate', {
                    type: 'browserId',
                    data: browserId
                });
                const userAgent = UAParser(navigator.userAgent);               
                this.$socket.emit('authorized', localStorage.user_id, localStorage.user_name, browserId, userAgent);
            }
        },

        push: function(message) {
            if (!("Notification" in window)) return;
            console.log(message.message)

            if (Notification.permission === "granted") {
                const notification = new Notification(message.message);
            } else if (Notification.permission !== "denied") {
                Notification.requestPermission().then(function(permission) {
                    if (permission === "granted") {
                        const notification = new Notification(message.message);
                    }
                });
            }
        },
        addedToGroup: function(message) {
            toastr.info(message.message)
        },
        driveProgress: function(message) {
            var data = {
                type: 'driveProgress',
                data: Math.round(message.message)
            }

            this.$store.dispatch('populate', data);
        },
        newReply: function(message) {
            toastr.info('<a href="' + window.baseUrl + '/#/thread/' + message.subforumId + '/' + message.topicId + '">New reply to your post "' + message.title + '"</a>', null, { timeOut: 0 });
            if (document.hidden && Notification.permission === 'granted') {
                var notification = new Notification('Think Tank Alert', {
                    body: 'New reply to your post "' + message.title + '"',
                });
            }
        },
        newFeedback: function(message) {
            toastr.warning('<a href="' + window.baseUrl + '/#/course/' + message.courseId + '">New feedback on your assignment</a>', null, { timeOut: 0 });
            if (document.hidden && Notification.permission === 'granted') {
                var notification = new Notification('Think Tank Alert', {
                    body: 'New feedback on your assignment',
                });
            }
        },
        genericMessage: function(message) {
            toastr.info(message.message);
        },
        reloadClient: function(message) { 
            console.log("Received message to reload")           
            toastr.info('Portal will reload in 30 seconds. Please save any work.')
            window.setTimeout(function() {      
                console.log("RELOADING CLIENT")      
                window.location.reload();
            }, 30000)
        },
        loggedInElsewhere: function(message) {
            toastr.error(message.message);
            window.setTimeout(function() {
                localStorage.clear();
                window.location.reload();
            }, 5000)
        },

        massLogoutWarning: function(message) {
            var options = {
                "closeButton": false,
                "newestOnTop": true,
                "positionClass": "toast-top-full-width",
                "showDuration": "0",
                "hideDuration": "0",
                "timeOut": "0",
                "extendedTimeOut": "0",
            }
            toastr.info('Portal will be going offline in ' + message.minutes + ' minutes for a quick server upgrade. ' + moment().format('YYYY-MM-DD hh:mma'), null, options);
        },
        massLogout() {
            var self = this;
            chat.rocketLogout();
            auth.logout(this).then(function(response) {

            });

            self.$bus.$emit('logout');
            self.$socket.emit('deauthorized', localStorage.user_id);
            
            const preservedSettings = ['preferred_resolution','preferred_speed','preferred_video_volume','selectedCourseSets'];

            Object.keys(localStorage).forEach((key)=> {
                if (!preservedSettings.includes(key)) {
                    localStorage.removeItem(key);
                }
            });

            if (!localStorage.getItem('selectedCourseSets') || localStorage.getItem('selectedCourseSets' === 'undefined')) {
                localStorage.setItem('selectedCourseSets','{}');
            }

            window.location.reload();

            self.$router.push('/');


        },
        chatUsers: function(users) {
            var data = {
                type: 'chatUsers',
                data: users
            }
            this.$store.dispatch('populate', data);
        },
        superAlert: function(message) {

            var options = {
                "closeButton": true,
                "newestOnTop": true,
                "positionClass": "toast-top-full-width",
                "showDuration": "0",
                "hideDuration": "0",
                "timeOut": "0",
                "extendedTimeOut": "0",
            }
            toastr.info(message.content, null, options);
            if (document.hidden && Notification.permission === 'granted') {
                var notification = new Notification('Think Tank Alert', {
                    body: message.content,
                });
            }
        },
        joined: function(user) {

            this.$store.dispatch('joinChat', user);
        },
        userWentOffline: function(userId) {
            console.log('BYE FELICIA');
            this.$store.dispatch('leaveChat', userId);
        },
        newInboxMessage: function(message) {
            var data = {
                type: 'messages',
                data: [message.message]
            }
            this.$store.dispatch('prepend', data);
            this.$store.dispatch('increment', 'unreadMessages');

        },
        newInboxReply: function(message) {
            this.$store.dispatch('increment', 'unreadMessages');
        },
        newChatMessage: function(message) {
            var openChats = this.$store.state.chatSessions.map(function(s) { return s.id });
            if (openChats.indexOf(message.conversationId) === -1) {
                this.$store.dispatch('push', { type: 'unreadChatMessages', data: message.conversationId });
            }
            this.$store.dispatch('addMessage', message);
        }

    },
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js